import { createSlice } from "@reduxjs/toolkit";
import type { DevToolsConfiguration, DevToolsConfigurationActionTypes } from "../types/devToolsState.types";
import { DEV_TOOLS_SLICE_NAME } from "../utils/storeUtils";

const initialState: DevToolsConfiguration = {
  showPanel: false,
  logQueries: false,
};

const devToolsConfigurationSlice = createSlice({
  name: DEV_TOOLS_SLICE_NAME,
  initialState,
  reducers: {
    update(state, action: DevToolsConfigurationActionTypes["update"]) {
      if (action.payload === undefined) {
        Object.assign(state, initialState);
      } else {
        Object.assign(state, action.payload);
      }
    },
    updateShowDevPanel(state, action: DevToolsConfigurationActionTypes["updateShowDevPanel"]) {
      state.showPanel = action.payload;
      if (state.showPanel === false) {
        state.logQueries = false;
        state.loggingItems = undefined;
      }
    },
  },
});

export default devToolsConfigurationSlice.reducer;
